export default "__VITE_ASSET__C0o61pNO__"